import { createIcon } from '@chakra-ui/icons';

export const ThumbsUp = createIcon({
  displayName: 'ThumbsUp',
  viewBox: '0 0 16 16',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M4.9458 6.40625V14.4063"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeMiterlimit="10"
      />
      <path
        d="M6.66044 1.9119L5.12972 6.40756H1.6123V14.0742L10.0559 14.9186C10.9703 15.01 11.8293 14.4666 12.1384 13.6012L14.3094 7.52268C14.6195 6.65435 13.9758 5.74089 13.0537 5.74089H8.94564L9.06584 2.35415C9.0907 1.65473 8.53037 1.07422 7.83057 1.07422C7.30144 1.07422 6.83097 1.41101 6.66044 1.9119Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>,
  ],
});
